module.exports = __webpack_public_path__ + "static/img/github.0c00801c.png";